export default __webpack_public_path__ + "assets/images/e1f5a0c60682a6140cf786abde7cf5c7.png";